import { Feature } from 'ol';
import { toLonLat, fromLonLat, transformExtent } from 'ol/proj';
import $j from 'jquery';
import { config } from '../../config/Config';
import { xmlToJson } from '../Utils/FormatUtils';
import { getTranslatedKey } from './TranslateUtils';
import { Circle, LineString, Point } from 'ol/geom';
import { Icon, Style } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { ImageWMS, TileWMS } from 'ol/source';
import TileLayer from 'ol/layer/Tile';
import { getCenter } from 'ol/extent';
import { toast } from 'react-toastify';
import { createXYZ } from 'ol/tilegrid';
import { loadFeatureCollection } from './UploadFilesUtils';
import Polygon, { circular } from 'ol/geom/Polygon';
import ImageLayer from 'ol/layer/Image';

/**
 *
 * @param {*} coords
 * @param {*} isGeolocalitzacio
 * @param {*} isETRS
 * @funcion para transformar las coordenadas a las correctas
 */
export function transformCoordsToCenter(coords, isGeolocalitzacio, isETRS) {
  let x = [coords[0], coords[1]];

  if (!isGeolocalitzacio) {
    if (isETRS) {
      x =
        typeof coords[0] === 'string'
          ? toLonLat([parseFloat(coords[0].replace(/\s/g, '')), parseFloat(coords[1].replace(/\s/g, ''))], config.EPSG)
          : toLonLat([coords[0], coords[1]], config.EPSG);
    }

    x = fromLonLat([x[0], x[1]], config.EPSG_mapa);
  }
  return x;
}

/**
 *
 * @param {*} coords
 * @param {*} map
 * @param {*} isGeolocalitzacio
 * @param {*} isETRS
 *
 * @desc funcion para centrar el mapa en unas coordenadas
 */
export async function centerMapTo(coords, map, isGeolocalitzacio, isETRS, altura, zoom, xinxeta = true) {
  await esborrarXinxeta(map);
  let x = transformCoordsToCenter(coords, isGeolocalitzacio, isETRS);
  map.getView().setProperties({ padding: [0, 0, altura, 0] });
  map.getView().setCenter(x);
  if (zoom) map.getView().setResolution(0.5);
  map.getView().setProperties({ padding: [0, 0, 0, 0] });
  if (xinxeta) {
    await afegirXinxeta(x, map);
  }
}

/**
 *
 * @param {*} map
 * @param {*} bbox
 * @desc funcion para hacer zoom a una bbox
 */
export function zoomMapToBBOX(map, bbox, altura, isQueryParam) {
  const catBbox = transformExtent([258000, 4485000, 536000, 4752000], config.EPSG, config.EPSG_mapa);

  const isOutside = bbox[0] < catBbox[0] || bbox[1] < catBbox[1] || bbox[2] > catBbox[2] || bbox[3] > catBbox[3];

  let fitOptions = {
    padding: isQueryParam ? [0, 0, 0, 0] : [60, 60, altura + 60, 60]
  };

  if (isOutside) {
    fitOptions.minResolution = 4;
  } else {
    fitOptions.minResolution = 1;
  }

  map.getView().fit(bbox, fitOptions);
}

/**
 *
 * @param {*} layer
 * @returns funcion para obtener el icono representativo de las capas externas
 */
export function getLegendURL(layer) {
  let url = '';
  let styleName = undefined;
  if (layer.getCurrentStyle() !== undefined) {
    styleName = layer.getCurrentStyle().getName();
  }
  let layerName = layer.getName();
  let layerUrl = layer.getOnlineResource();
  if (layerUrl !== undefined) {
    let legendUrl = layerUrl.replace('owsseg', 'ows').replace('owssec', 'ows');
    if (styleName === undefined || styleName == null) {
      url =
        legendUrl.replace('?', '').replace('/wmts/service', '') +
        '?LAYER=' +
        layerName +
        '&REQUEST=GetLegendGraphic' +
        '&VERSION=' +
        config.capabilities_version +
        '&FORMAT=image/png&WIDTH=20&HEIGHT=20&TRANSPARENT=TRUE';
    } else {
      url =
        legendUrl.replace('?', '').replace('/wmts/service', '') +
        '?LAYER=' +
        layerName +
        '&REQUEST=GetLegendGraphic&VERSION=' +
        config.capabilities_version +
        '&FORMAT=image/png' +
        '&WIDTH=20&HEIGHT=20' +
        '&TRANSPARENT=TRUE' +
        '&STYLE=' +
        styleName;
    }
    url = 'url(' + url + ')';
    return url;
  }
  return false;
}

/**
 *
 * @param {*} layer
 * @param {*} map
 * @param {*} arrayLayers
 * @param {*} external
 * @param {*} style
 * @param {*} filter En caso de que haya filtro en la capa, pediremos la capa con el filtro
 *
 * @desc funcion para crear y añadir una capa al mapa
 */
export async function createLayer(layer, map, arrayLayers, external, style, filter) {
  let url = layer.getOnlineResource();
  // if (!url.startsWith('/')) url = '/proxyWMS.php?url=' + url;
  filter = filter ? filter.replace(/%25/g, '%') : undefined;

  if (!style) {
    const name = layer.getStyle(layer.getStyleSelected())?.getName();
    name ? (style = name) : (style = '');
  }

  var tileGrid = createXYZ({
    // extent: transformExtent([258000, 4485000, 536000, 4752000], config.EPSG, config.EPSG_mapa),
    tileSize: 512
  });

  let sourceWMS = new ImageWMS({
    url: url,
    crossOrigin: 'Anonymous',
    params: {
      LAYERS: layer.getName(),
      TRANSPARENT: true,
      SERVICE: 'WMS',
      VERSION: config.capabilities_version,
      // WIDTH: 512,
      // HEIGHT: 512,
      STYLES: style,
      // TILED: false,
      SRS: config.EPSG_mapa,
      FORMAT_OPTIONS: 'dpi:72',
      CQL_FILTER: filter
    },
    serverType: 'geoserver',
    tileGrid: tileGrid
  });

  let sitepLayer = new ImageLayer({
    source: sourceWMS
  });

  sourceWMS.on('tileloadstart', function (event) {
    event.tile.getImage().addEventListener('error', function (error) {
      layer.setError(true);
    });
  });

  layer.setOLLayer(sitepLayer);

  if (arrayLayers.find((l) => l.getTitle() + l.getName() === layer.getTitle() + layer.getName()) === undefined) {
    arrayLayers.unshift(layer);
  }
  await map.addLayer(layer.getOLLayer());
}

export async function getCapabilities() {
  let url = `/viewerHtml/capabilities.xml`;

  let resp = await fetch(url);
  let xmlText = await resp.text();

  let parser = new DOMParser();
  let xmlDoc = parser.parseFromString(xmlText, 'text/xml');

  return xmlDoc;
}

export async function getLayerBbox(layer, capabilites) {
  let title = layer.getName();
  let crs = 'EPSG:25831';

  let layerNodes = capabilites.getElementsByTagName('Layer');
  let layerNode;

  for (let i = 0; i < layerNodes.length; i++) {
    let layerTitle = layerNodes[i].getElementsByTagName('Title')[0].childNodes[0].nodeValue;
    let crsNodes = layerNodes[i].getElementsByTagName('CRS');
    let crsMatch = false;

    for (let j = 0; j < crsNodes.length; j++) {
      if (crsNodes[j].childNodes[0].nodeValue === crs) {
        crsMatch = true;
        break;
      }
    }

    if (layerTitle === title && crsMatch) {
      layerNode = layerNodes[i];
      break;
    }
  }

  if (!layerNode) {
    return;
  }

  let bboxNodes = layerNode.getElementsByTagName('BoundingBox');
  let bboxNode;

  for (let i = 0; i < bboxNodes.length; i++) {
    if (bboxNodes[i].getAttribute('CRS') === crs) {
      bboxNode = bboxNodes[i];
      break;
    }
  }

  if (!bboxNode) {
    return;
  }

  let bboxSum = [
    Number(bboxNode.getAttribute('minx')),
    Number(bboxNode.getAttribute('miny')),
    Number(bboxNode.getAttribute('maxx')),
    Number(bboxNode.getAttribute('maxy'))
  ];

  bboxSum = transformExtent(bboxSum, config.EPSG, config.EPSG_mapa);
  return bboxSum;
}

/**
 *
 * @param {*} lon
 * @param {*} lat
 * @param {*} context
 * @desc funcion para obtener direccion y municipio a partir de unas coordenadas a traves del geocodificador del icgc
 */
let $llamadaInfo;

export async function obtenirInfoPunt(lon, lat, context) {
  if ($llamadaInfo != null) {
    $llamadaInfo.abort();
    $llamadaInfo = null;
  }
  var self = context;

  if (lon !== null) var sUsrname = 'dptop';
  var fPwd = '5eAEHUcQRkwzN2TCL9t9pk7S2GE=';
  var header =
    '<soapenv:Envelope ' +
    "soapenv:encodingStyle='http://schemas.xmlsoap.org/soap/encoding/' xmlns:soapenv='http://schemas.xmlsoap.org/soap/envelope/' xmlns:xsd='http://www.w3.org/2001/XMLSchema' xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance' xmlns:SOAP-ENC='http://schemas.xmlsoap.org/soap/encoding/' xmlns:si='http://soapinterop.org/xsd' xmlns:tns='urn:idecwsdl'>" +
    '<soapenv:Header><wsse:Security xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd" soapenv:mustUnderstand="1">' +
    '<wsse:UsernameToken xmlns:wsu="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd" wsu:Id="UsernameToken-32685187">' +
    '<wsse:Username>' +
    sUsrname +
    '</wsse:Username>' +
    '<wsse:Password Type="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordDigest">' +
    fPwd +
    '</wsse:Password>' +
    '<wsse:Nonce></wsse:Nonce>' +
    '<wsu:Created></wsu:Created>' +
    '</wsse:UsernameToken>' +
    '</wsse:Security>' +
    '</soapenv:Header>';
  var post2 = '/ws/wss_1.0 HTTP/1.1';
  var post =
    '<soapenv:Body><geocodificacioInversaInput xmlns="http://ws.icc.cat/geocodificador/">' +
    '' +
    ' <puntUTMETRS89 xmlns="">' +
    '<X>' +
    lat +
    '</X><Y>' +
    lon +
    '</Y> ' +
    '</puntUTMETRS89>' +
    '<puntUTMED50 xmlns=""> </puntUTMED50> ' +
    '<puntLonLatED50> </puntLonLatED50> ' +
    '<puntLonLatETRS89> </puntLonLatETRS89>' +
    '</geocodificacioInversaInput></soapenv:Body></soapenv:Envelope>';

  var SOAPAction = 'http://www.icc.cat/geocodificador/ws/wss_1.0#obtenirInfoPunt';

  $llamadaInfo = $j.ajax({
    type: 'POST',
    url: config.geocodificador,
    data: header + post,
    contentType: 'text/xml',
    dataType: 'xml',
    cache: false,
    beforeSend: function (xhr) {
      xhr.setRequestHeader('SOAPAction', SOAPAction);
      xhr.setRequestHeader('POST', post2);
      xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
    },
    success: function (data) {
      var jsonContext = xmlToJson(data);
      var envelope = jsonContext['soapenv:Envelope'];
      var body = envelope['soapenv:Body'];
      var info = body.geocodificacioInversaOutput;
      self.setState({ adreça: null, municipi: null });
      var adreça = null;
      if (
        info !== undefined &&
        info.adrecaInversa !== undefined &&
        info.adrecaInversa.municipi !== undefined &&
        info.adrecaInversa.municipi.nom !== undefined &&
        info.adrecaInversa.municipi.nom['#text'] !== undefined
      ) {
        self.setState({ municipi: info.adrecaInversa.municipi.nom['#text'] });
        if (info.adrecaInversa.via !== undefined && info.adrecaInversa.via.valid !== undefined && info.adrecaInversa.via.valid['#text'] === 'true') {
          if (info.adrecaInversa.via.Tipus !== undefined && info.adrecaInversa.via.Tipus['#text'] !== '') {
            adreça = info.adrecaInversa.via.Tipus['#text'] + ' ';
          }
          if (
            info.adrecaInversa.via.Article !== undefined &&
            info.adrecaInversa.via.Article['#text'] !== undefined &&
            info.adrecaInversa.via.Article['#text'] !== ''
          ) {
            adreça += info.adrecaInversa.via.Article['#text'];
            let article = info.adrecaInversa.via.Article['#text'];
            if (article[article.length - 1] !== "'") {
              adreça += ' ';
            }
          }
          adreça += info.adrecaInversa.via.Nom['#text'];

          if (
            info.adrecaInversa.portalParell !== undefined &&
            info.adrecaInversa.portalParell['#text'] !== undefined &&
            info.adrecaInversa.portalParell['#text'] !== ''
          ) {
            adreça += ' ' + info.adrecaInversa.portalParell['#text'];
          } else if (
            info.adrecaInversa.portalSenar !== undefined &&
            info.adrecaInversa.portalSenar['#text'] !== undefined &&
            info.adrecaInversa.portalSenar['#text'] !== ''
          ) {
            adreça += ' ' + info.adrecaInversa.portalSenar['#text'];
          }
          self.setState({ adreça: adreça });
        }
      }
    },
    failure: function (errMsg) {
      toast.error(getTranslatedKey('error_obtainPointInfo'), { autoClose: 4000, pauseOnHover: true });
    }
  });
}

/**
 *
 * @param {*} lon
 * @param {*} lat
 * @param {*} context
 * @desc funcion para obtener altura a partir de unas coordenadas a traves del geocodificador del icgc
 */
let $llamadaAlçada;
export async function obtenirAlçada(lon, lat, context) {
  if ($llamadaAlçada != null) {
    $llamadaAlçada.abort();
    $llamadaAlçada = null;
  }
  var self = context;
  let xmin = lon - 10;
  let ymin = lat - 10;
  let xmax = lon + 10;
  let ymax = lat + 10;

  let url =
    'https://geoserveis.icgc.cat/icc_mdt/wcs/service?SERVICE=WMS&LAYERS=icc:met5&QUERY_LAYERS=icc:met5&STYLES=&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&BBOX=' +
    xmin +
    ',' +
    ymin +
    ',' +
    xmax +
    ',' +
    ymax +
    '&FEATURE_COUNT=1000&HEIGHT=11&WIDTH=11&FORMAT=image%2Fpng&SRS=EPSG%3A25831&INFO_FORMAT=application/json&X=6&Y=6';

  fetch(
    config.url_proxy_openlayers +
      new URLSearchParams({
        url: url,
        mode: 'native'
      }),
    {
      method: 'GET'
    }
  )
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      if (json.features !== undefined && json.features[0] !== undefined && json.features[0].properties !== undefined) {
        self.setState({ alçada: json.features[0].properties.GRAY_INDEX.toFixed(2) });
      }
    })
    .catch((error) => {
      self.setState({ alçada: null });
    });
}

/**
 * @param {*} coordenades
 * @desc Función encargada de añadir una chincheta en el lugar de un clic del usuario
 */
export async function afegirXinxeta(coordenades, map) {
  //primer esborrem la antiga xinxeta
  await esborrarXinxeta(map);
  //segon creem la feature que contindrá el png de la xinxeta y el punt
  const iconFeature = new Feature({
    geometry: new Point(coordenades)
  });
  const iconStyle = new Style({
    image: new Icon({
      color: '#fff',
      crossOrigin: 'Anonymous',
      anchor: [24, 60],
      anchorXUnits: 'pixels',
      anchorYUnits: 'pixels',
      scale: 0.5,
      src: require('../../images/01-icon-location.png')
    })
  });

  iconFeature.setStyle(iconStyle);

  const vectorSource = new VectorSource({
    features: [iconFeature]
  });

  const vectorLayer = new VectorLayer({
    source: vectorSource,
    name: 'xinxeta',
    zIndex: '15'
  });

  //finalment afeguim la xinxeta al mapa
  await map.addLayer(vectorLayer);
}

/**
 * @desc Función encargada de eliminar el elemento de la chincheta en el mapa
 */
export async function esborrarXinxeta(map) {
  const xinxetaAntiga = map.getAllLayers().filter((layer) => {
    if (layer['values_'].name !== undefined && layer['values_'].name === 'xinxeta') return layer;
  });

  for (let i = 0; i < xinxetaAntiga.length; ++i) {
    await map.removeLayer(xinxetaAntiga[i]);
  }
}

export async function getFeatureInfoExternes(capes, map, mapHeight, mapWidth, clickPixel) {
  await esborrarXinxeta(map);
  let ext = map.getView().calculateExtent(map.getSize());
  let bbox = ext[0] + ',' + ext[1] + ',' + ext[2] + ',' + ext[3];

  var obrir = false;
  var result = '<!DOCTYPE html><html><body style="font-family:Verdana,Arial;"><h3>Dades de WMS externs</h3><br>';
  var result_aux = '';
  var clear = true;
  let buffer = 5;
  if (window.innerWidth <= 768) buffer = 15;
  for (var i in capes) {
    if (capes[i].isVisible() && capes[i].hasInfoEnabled()) {
      let onlineResource = capes[i].getOnlineResource();
      if (onlineResource.includes('http:')) onlineResource = onlineResource.replace('http:', 'https:');
      if (!onlineResource.includes('?')) onlineResource += '?';
      var url = onlineResource + '&LAYERS=' + capes[i].getName() + '&QUERY_LAYERS=' + capes[i].getName();
      url += '&STYLES=&SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&BBOX=' + bbox;
      url +=
        '&FEATURE_COUNT=1000&HEIGHT=' +
        mapHeight.split('px')[0] +
        '&WIDTH=' +
        mapWidth.split('px')[0] +
        '&FORMAT=image%2Fpng&INFO_FORMAT=text/html&BUFFER=' +
        buffer;
      url += '&SRS=' + config.EPSG_mapa;
      url += '&X=' + clickPixel[0] + '&Y=' + clickPixel[1] + '&I=' + clickPixel[0] + '&J=' + clickPixel[1];

      result_aux =
        '<h4>' +
        capes[i].getName() +
        '</h4><iframe frameBorder=\'0\' style="width:100%;height:600px;" src="' +
        url +
        '"></iframe><br><br>' +
        result_aux;
      obrir = true;
    }
  }
  if (obrir) {
    result += result_aux + '</body></html>';
    var win = window.open('', 'WMS externs', 'width=800,height=700,scrollbars=1');
    if (clear) {
      if (!win || win.closed || typeof win.closed == 'undefined') {
        toast.info(getTranslatedKey('error_popUpsBlocked'), { autoClose: 4000, pauseOnHover: true });
        return;
      }
      win.close();
      win = window.open('', 'WMS externs', 'width=800,height=700,scrollbars=1');
      clear = false;
    }
    if (!win || typeof win.document === 'undefined') {
      toast.info(getTranslatedKey('error_popUpsBlocked'), { autoClose: 4000, pauseOnHover: true });
      return;
    }
    win.document.write(result);
    win.focus();
  }
}

export const repaintLayers = (map, arrayLayers) => {
  arrayLayers.forEach((capa) => {
    map.removeLayer(capa.getOLLayer());
  });
  arrayLayers.reverse().forEach((capa, i) => {
    map.addLayer(capa.getOLLayer());
  });
  arrayLayers.reverse();
};

export const loadRedLining = (fc, rlSource, map, arrayLayers, handleLayerChange) => {
  const rlFeatures = [];
  const localFileFeature = [];

  fc.forEach((feat) => {
    if (feat.get('redlining')) {
      rlFeatures.push(feat);
    } else {
      localFileFeature.push(feat);
    }
  });

  rlFeatures.forEach((feature) => {
    if (feature.get('isCircle')) {
      const geom = feature.getGeometry();
      const extent = geom.getExtent();
      const center = getCenter(extent);
      const coord = geom.getCoordinates();
      const vertex = coord[0][0];
      const line = new LineString([center, vertex]);
      const radius = line.getLength() * 0.74;
      let circle = new Circle(center, radius);
      let circleFeature = new Feature(circle);
      rlSource.addFeature(circleFeature);
    } else {
      rlSource.addFeature(feature);
    }
  });

  loadFeatureCollection(localFileFeature, map, arrayLayers, handleLayerChange, getTranslatedKey('localFileName'));
};

export const removeLayer = (map, layerName, arrayLayers, arrayExternalLayers, handleDeleteLayer, deleteTaula) => {
  if (layerName) layerName.trim();
  const layer = arrayLayers.find((l) => l.getName() === layerName);
  let index = arrayLayers.findIndex((l) => l.getName() === layerName);
  if (index !== -1) {
    layer.setExpanded(false);
    layer.setTransPopUpOpen(false);
    layer.setVisible(true);
    layer.setExportOpen(false);
    layer.setStylesOpen(false);
    layer.setStatsOpen(false);

    if (layer.getOLLayer() !== undefined) {
      map.removeLayer(layer.getOLLayer());
      layer.getOLLayer().setOpacity(100 / 100);
      layer.setStyleSelected(0);
      layer.setOLLayer(undefined);
    }
    layer.setChecked(false);
    arrayLayers.splice(index, 1);
    if (layer.isExternal()) {
      let extLayer = arrayExternalLayers.findIndex((l) => l.getTitle() === layer.getTitle());
      arrayExternalLayers.splice(extLayer, 1);
    }
    handleDeleteLayer(layer);
    deleteTaula(layer);
  }
};

export const convertCircleToPolygon = (geometry) => {
  let center = geometry.getCenter();
  const radius = geometry.getRadius();
  center = toLonLat(center, config.EPSG_mapa);
  const circlePolygon = circular(center, radius);
  let circlePolConverted = circlePolygon.getCoordinates()[0].map((coord) => {
    return fromLonLat(coord, config.EPSG_mapa);
  });
  let pol = new Polygon([circlePolConverted]);
  let feature = new Feature({ geometry: pol });
  return feature;
};
